import { render, staticRenderFns } from "./ot-radio-group-wrapper.vue?vue&type=template&id=e41520b8&scoped=true&"
import script from "./ot-radio-group-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-radio-group-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-radio-group-wrapper.vue?vue&type=style&index=0&id=e41520b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41520b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VBtn,VForm})
